// ─── Lo que viaja a Dataico, en UNA sola puerta ──────────────────────────────
// La factura y la nota crédito arman sus ítems para Dataico igual, y antes cada
// una lo hacía por su lado. Se separaron: la factura aprendió a mandar la tarifa
// de IVA de CADA línea y la nota crédito se quedó con un 19% quemado. Una nota
// crédito sobre una línea excluida habría viajado a la DIAN con un IVA que la
// factura nunca cobró, y su total no habría cuadrado con el de AURA (que sí
// suma el IVA línea por línea con el régimen congelado).
//
// Aquí vive también el medio de pago, con su etiqueta en español.
import { regimenDeLinea } from "./iva.js";
import { parseNumber } from "./utils.js";

// Un ítem de factura o de nota crédito tal como lo pide Dataico. La tarifa sale
// de `regimenDeLinea`, la misma puerta con la que AURA calcula el IVA del
// documento: con el régimen CONGELADO de la línea cuando lo trae (la nota
// crédito hereda el de la factura que reversa), o con el del producto.
export function itemDataico(it) {
  return {
    // REF (sku) = nombre del producto, no la referencia interna.
    sku: it.articulo || it.referencia || "ITEM",
    quantity: parseNumber(it.cantidad) || 1,
    description: it.descripcion || it.articulo || "Ítem",
    measuring_unit: "94",
    price: parseNumber(it.precio_unitario) || 0,
    taxes: [{ tax_category: "IVA", tax_rate: regimenDeLinea(it).pct }]
  };
}

// ─── Medio de pago ───────────────────────────────────────────────────────────
// Los códigos son los de Dataico; la etiqueta es lo que ve quien factura.
export const MEDIOS_PAGO_DATAICO = [
  { codigo: "CREDIT_TRANSFER", etiqueta: "Transferencia bancaria" },
  { codigo: "DEBIT_TRANSFER", etiqueta: "Transferencia débito" },
  { codigo: "DEBIT_AHORRO", etiqueta: "Débito a cuenta de ahorros" },
  { codigo: "CASH", etiqueta: "Efectivo" },
  { codigo: "CHEQUE", etiqueta: "Cheque" },
  { codigo: "CREDIT_CARD", etiqueta: "Tarjeta de crédito" },
  { codigo: "DEBIT_CARD", etiqueta: "Tarjeta débito" },
  { codigo: "MUTUAL_AGREEMENT", etiqueta: "Acuerdo mutuo (sin instrumento definido)" }
];

// Los clientes de Mathiz pagan por transferencia.
export const MEDIO_PAGO_DEFECTO = "CREDIT_TRANSFER";

// El medio con el que se propone la próxima factura. «Acuerdo mutuo» era el
// valor que AURA ponía SOLO, no una elección de nadie: todas las facturas
// electrónicas salieron así (código DIAN ZZZ, que Dataico devuelve como
// «OTHER»). Por eso un acuerdo mutuo guardado sin la marca `medio_pago_elegido`
// se cambia por el de defecto; elegido a propósito, se respeta.
export function medioPagoDe(cfg) {
  const c = cfg || {};
  const m = String(c.payment_means || "").trim();
  if (!m) return MEDIO_PAGO_DEFECTO;
  if (m === "MUTUAL_AGREEMENT" && !c.medio_pago_elegido) return MEDIO_PAGO_DEFECTO;
  return m;
}

export function etiquetaMedioPago(codigo) {
  const m = MEDIOS_PAGO_DATAICO.find(x => x.codigo === codigo);
  return m ? m.etiqueta : (codigo || "");
}
